module.exports = __webpack_public_path__ + "static/media/laxmiraj-scop.41946fe6.png";